import {postEventSongAddGuest} from "../../../../helpers/event_helper.js";

// action
import {eventSongVoteSuccess, eventSongVoteError} from "./reducer";
import {loginGuestSuccess} from "../../../auth/profile/reducer";
import {authUserManager} from "../../../../helpers/api_helper";

export const voteSongGuest = (payload) => async (dispatch) => {
  try {
    let response;
    response = postEventSongAddGuest(
      payload
    );
    const data = await response;
    if (data) {
      dispatch(eventSongVoteSuccess(data));
      if (data.registeredGuest) {
        authUserManager.setGuest(data.registeredGuest)
        dispatch(loginGuestSuccess(data.registeredGuest))
      }
    }
  } catch (error) {
    dispatch(eventSongVoteError(error));
  }
};
